import * as $ from 'jquery';
import { IEventAggregator, IDisposable, disposableSubscription } from 'common/barrels/core';
import { Observable, AsyncSubject } from 'common/barrels/rx';
import { IResourceProvider } from 'common/resourceprovider';
import { Screen } from 'runtime/screens/screen';
import { Request } from 'common/request';

import { WorkflowDefinition } from 'runtime/data/workflowdefinition';
import * as rxui from 'common/rxui/core';
import * as path from 'shared/path';
import { maxDefaultZero } from 'common/functions/array';
import { Seq } from 'immutable';

import { Serializer } from 'common/serializer';

import 'runtime/styles/screens/createdefinition.less';

export class CreateDefinition extends Screen {
    private $definitionFilter: JQuery;

    private createDefinitionDisposable: IDisposable;

    constructor($hostElement: JQuery, resourcesObservable: Observable<IResourceProvider>, parentEventAggregator: IEventAggregator, serializer: Serializer, csrfToken: () => string) {
        super($hostElement, resourcesObservable, parentEventAggregator, serializer, csrfToken);

        this.$element = $('<div />').addClass('wf-container wf-createdefinition-container').appendTo($hostElement).on('remove', () => this.dispose());

        var subject = new AsyncSubject<WorkflowDefinition[]>();
        var subjectSubscription: IDisposable = null;
        subjectSubscription = disposableSubscription(this.resourcesAvailable.zip(subject, (v1, v2) => v2).subscribe(definitions => {
            this.buildContainer(this.$element, this.resources, definitions);

            this.maxSameSize();

            this.createDefinitionDisposable = disposableSubscription(
                this.screenDisposable,

                subjectSubscription,
                subject,

                rxui.windowResized().debounceTime(250).subscribe(() => this.maxSameSize()),
                rxui.focusin(this.$definitionFilter).switchMap(event => rxui.input(event.target).auditTime(300).takeUntil(rxui.focusout(this.$definitionFilter).map(e => e))).subscribe(event => {
                        var $target = $(event.target);
                        var val: string = $target.val();
                        $('.wf-createdefinition-item', this.$element).each((index, elem) => {
                            var $elem = $(elem);
                            var title: string = $elem.data('definition-title');
                            if (val === '' || title.toLowerCase().indexOf(val.toLowerCase()) >= 0) {
                                $elem.css('display', 'inline-table');
                            } else {
                                $elem.css('display', 'none');
                            }
                        });
                    }),
                rxui.click($('.wf-createdefinition-item-action .activitybutton', this.$element)).throttleTime(1000).subscribe(
                    mouseEvent => {
                        var $target = $(mouseEvent.target);
                        var $item = $target.closest('.wf-createdefinition-item');
                        var definitionName = $item.data('definition-name');
                        this.create(definitionName);
                    }
                )
            );
        }));

        Request.create(serializer, path.api('definitions'))
            .handleArray(WorkflowDefinition, value => (subject.next(value), subject.complete()))
            .handle(null, value => (subject.next([]), subject.complete()))
            //.handle(messages.SystemError, x => this.systemError(x))
            //.error((jqXhr, textStatus, errorThrown) => this.httpError(errorThrown, textStatus))
            //.final(() => this.eventAggregator.publish(new NotBusy()))
            .get();
    }

    dispose(): void {
        this.createDefinitionDisposable.dispose();
    }

    remove(): void {
        this.$element.remove();
        this.dispose();
    }

    private buildContainer($element: JQuery, resources: IResourceProvider, definitions: WorkflowDefinition[]): void {
        const comparer = (a: WorkflowDefinition, b: WorkflowDefinition) => a.displayIndex !== b.displayIndex
            ? a.displayIndex - b.displayIndex
            : (a.definitionTitle || '').toLowerCase().localeCompare((b.definitionTitle || '').toLowerCase());

        const definitionItems = definitions.filter(x => !x.hidden).sort(comparer).map(d => {
            return $('<div />').addClass('wf-createdefinition-item').data('definition-name', d.definitionName).data('definition-title', d.definitionTitle).append([
                $('<div />').addClass('wf-createdefinition-item-title').text(d.definitionTitle),
                $('<div />').addClass('wf-createdefinition-item-description').text(d.definitionDescription),
                $('<div />').addClass('wf-createdefinition-item-action').append(
                    $('<div />').activityButton(this.eventAggregator, resources, { contentText: resources.getCoreString('XamlCreateRequest') })
                )
            ]);
        });

        this.$definitionFilter = $('<div />').textBox(this.eventAggregator, this.resources, { contentText: null });
        $('input', this.$definitionFilter).attr('placeholder', resources.getCoreString('XamlSearchForms'));

        $element.append(
            $('<div />').addClass('wf-outer wf-createdefinition-outer').append([
                $('<div />').addClass('wf-header wf-createdefinition-header').append([
                    $('<div />').addClass('wf-createdefinition-filter-group').append([
                        $('<div />').addClass('wf-createdefinition-filter-label').text(resources.getCoreString('XamlSelectAForm')),
                        $('<div />').addClass('wf-createdefinition-filter').append([
                            this.$definitionFilter
                        ])
                    ]),
                    $('<hr />').addClass('wf-createdefinition-header-hr')
                ]),
                $('<div />').addClass('wf-inner wf-createdefinition-inner').append([
                    $('<div />').addClass('wf-createdefinition-paddingcontainer').append(definitionItems)
                ])
            ])
        );
    }

    private maxSameSize(byRow: boolean = true) {
        var $definitions = $('.wf-createdefinition-item', this.$element[0]);

        var a: { topOffSet: number; $title: JQuery; $description: JQuery }[] = [];

        $definitions.each((index: number, elem: Element) => {
            var $elem = $(elem);
            a.push({
                topOffSet: $elem.offset().top,
                $title: $elem.children('.wf-createdefinition-item-title'),
                $description: $elem.children('.wf-createdefinition-item-description')
            });
        });

        var dataOrValue = ($elem: JQuery, key: string, f: () => any) => {
            var data = $elem.data(key);
            if (data === undefined) {
                var v = f();
                $elem.data(key, v);
                return v;
            }
            else {
                return data;
            }
        };

        var getTitleHeight = x => dataOrValue(x.$title, 'titleHeight', () => x.$title.outerHeight());
        var getDescriptionHeight = x => dataOrValue(x.$description, 'descriptionHeight', () => x.$description.outerHeight());

        var act = (enumerable: { topOffSet: number; $title: JQuery, $description: JQuery }[]) => {
            var maxTitleHeight = Math.ceil(maxDefaultZero(enumerable.map(x => getTitleHeight(x))));
            var maxDescriptionHeight = Math.ceil(maxDefaultZero(enumerable.map(x => getDescriptionHeight(x))));

            enumerable.forEach(ge => {
                ge.$title.outerHeight(Math.max(getTitleHeight(ge), maxTitleHeight));
                ge.$description.outerHeight(Math.max(getDescriptionHeight(ge), maxDescriptionHeight));
            });
        };

        if (byRow) {
            Seq(a).groupBy(elem => elem.topOffSet).forEach(x => act(x.toArray()));
        } else {
            act(a);
        }
    }
}